import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "universal-cookie";

import { useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import AgapeLoading from "../../components/common/loading/Loading";
import ChargeWalletDesktop from "../../components/other/chargeWallet/ChargeWalletDesktop";
import NewInstantPaymentDialog from "../../components/other/home/components/components_old/components/NewInstantPaymentDialog";
import IntroducingOrganizationDesktop from "../../components/other/introducingOrganization/IntroducingOrganizationDesktop";
import IntroducingOrganizationMobile from "../../components/other/introducingOrganization/IntroducingOrganizationMobile";
import { setMe } from "../../redux/slices/me";
import { open } from "../../redux/slices/organizationRegistation";

import {
  getApiService,
  getFooterMenu,
  getMainMenu,
  getMobileMenu,
} from "../../services/AgapeAPI";
import DialogInstallPWA from "./install/DialogInstallPWA";

const PublicMobile = dynamic(() => import("./PublicMobile"), {
  loading: () => <AgapeLoading internal={false} />,
});

const PublicDesktop = dynamic(() => import("./PublicDesktop"), {
  loading: () => <AgapeLoading internal={false} />,
});

const cookies = new Cookies();

// data, mobileMenu, footer, menu, ...props
const Public = (props) => {
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const router = useRouter();

  const [mobileMenu, setMobileMenu] = React.useState(null);
  const [footer, setFooter] = React.useState(null);
  const [menu, setMenu] = React.useState(null);
  const [showTopMenu, setShowTopMenu] = React.useState(false);
  const [banner, setBanner] = React.useState();
  const orgOpen = useSelector(open);

  const getApiMobileMenu = () => {
    getMobileMenu()
      .then((res) => {
        setMobileMenu(res.data[0]);
      })
      .catch(() => {
        setTimeout(() => {
          getApiMobileMenu();
        }, 5000);
      });
  };

  const getApiFooterMenu = () => {
    getFooterMenu()
      .then((res) => {
        setFooter(res.data[0]);
      })
      .catch(() => {
        setTimeout(() => {
          getApiFooterMenu();
        }, 5000);
      });
  };

  const getApiMainMenu = () => {
    getMainMenu()
      .then((res) => {
        setMenu(res.data[0]);
      })
      .catch(() => {
        setTimeout(() => {
          getApiMainMenu();
        }, 5000);
      });
  };

  const getUserData = () => {
    getApiService("ums/me")
      .then((res) => {
        setShowTopMenu(true);
        dispatch(setMe(res.data));
        if (res.data) {
          cookies.set("isLoggedIn", "1");
          if (res.data.roles !== null && res.data.roles.length > 0) {
            cookies.set("hasDashboard", "1");
          }
        } else {
          cookies.set("isLoggedIn", "0");
          cookies.set("hasDashboard", "0");
          localStorage.clear();
        }
      })
      .catch(() => {
        if (router.asPath.includes("profile")) {
          router.push(`/login?from=${router.asPath}`);
        }
        setShowTopMenu(true);
        cookies.set("isLoggedIn", "0");
        cookies.set("hasDashboard", "0");
        localStorage.clear();
      });
  };

  const getBannerData = () => {
    getApiService("main-landings/marketing-banner")
      .then((res) => {
        setBanner(res.data.data);
      })
      .catch(() => {
        setTimeout(() => {
          getBannerData();
        }, 5000);
      });
  };

  React.useEffect(() => {
    getApiMobileMenu();
    getApiFooterMenu();
    getApiMainMenu();
    getUserData();
    getBannerData();
  }, []);

  return (
    <>
      {isMobile ? (
        <>
          <PublicMobile {...props} mobileMenu={mobileMenu} footer={footer} />
          {/* <ChargeWalletMobile /> */}
          {orgOpen && <IntroducingOrganizationMobile />}
        </>
      ) : (
        <>
          <PublicDesktop
            {...props}
            footer={footer}
            menu={menu}
            showTopMenu={showTopMenu}
            banner={banner}
          />
          {orgOpen && <IntroducingOrganizationDesktop />}
        </>
      )}
      <ChargeWalletDesktop />
      <NewInstantPaymentDialog />
    </>
  );
};

export default Public;
